// extracted by mini-css-extract-plugin
export var contentBody = "_d7-9";
export var headerImage = "_d7-2";
export var imageButton = "_d7-7";
export var imageButtonIcon = "_d7-8";
export var imageHeader = "_d7-4";
export var imageHeaderText = "_d7-5";
export var imageOverlay = "_d7-3";
export var imageTitle = "_d7-6";
export var imageWrapper = "_d7-1";
export var taskList = "_d7-a";
export var widget = "_d7-0";